const Loader = () => {
  return <div class="loader" />;
};

export default Loader;
